export class ParticipantsManager {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
        this.init();
    }

    init() {
        // Écouter les changements sur les champs adultes et enfants
        const adultsField = this.wrapper.querySelector('.gf-sejour-adults');
        const childrenField = this.wrapper.querySelector('.gf-sejour-children');

        if (adultsField) {
            adultsField.addEventListener('change', () => this.updateVisibility());
            adultsField.addEventListener('input', () => this.updateVisibility());
        }
        if (childrenField) {
            childrenField.addEventListener('change', () => this.updateVisibility());
            childrenField.addEventListener('input', () => this.updateVisibility());
        }

        // Initialiser si on est déjà sur la bonne page
        this.updateVisibility();
    }

    updateVisibility() {
        // Lire le nombre de participants (adultes + enfants)
        this.gform.readParticipants();
        const participantCount = this.gform.state.adults + this.gform.state.children;

        // Trouver toutes les sections avec la classe gf-participant-group-X
        // Il peut y avoir plusieurs sections avec la même classe (ex: gf-participant-group-2 pour "Personne en charge" ET "Participant 2")
        for (let i = 2; i <= 15; i++) {
            const sections = this.wrapper.querySelectorAll(`.gf-participant-group-${i}.gsection`);

            sections.forEach((section, sectionIndex) => {
                // Déterminer le nombre de champs à récupérer
                // La première section gf-participant-group-2 (Personne en charge) a 5 champs
                // Les autres sections ont 3 champs (prénom, nom, date de naissance)
                const isReservationOwner = i === 2 && sectionIndex === 0;
                const fieldCount = isReservationOwner ? 5 : 3;

                // Trouver les champs suivants
                const fieldsToToggle = this.getFollowingFields(section, fieldCount);

                // La personne en charge de la réservation (première section group-2) est toujours visible
                // Les autres participants sont visibles selon le nombre de participants
                let shouldShow;
                if (isReservationOwner) {
                    // Toujours afficher la personne en charge de la réservation
                    shouldShow = true;
                } else {
                    // Pour les autres participants, calculer leur index réel
                    // gf-participant-group-2 (2ème occurrence) = Participant 2
                    // gf-participant-group-3 = Participant 3, etc.
                    const participantIndex = (i === 2 && sectionIndex === 1) ? 2 : i;
                    shouldShow = participantIndex <= participantCount;
                }

                if (shouldShow) {
                    // Afficher le groupe
                    section.style.display = '';
                    fieldsToToggle.forEach(field => {
                        field.style.display = '';
                        this.enableFields(field);
                        this.setFieldsRequired(field, true);
                    });
                } else {
                    // Masquer le groupe
                    section.style.display = 'none';
                    fieldsToToggle.forEach(field => {
                        field.style.display = 'none';
                        this.disableFields(field);
                        this.setFieldsRequired(field, false);
                    });
                }
            });
        }

        // Convertir les champs date Gravity Forms en input type="date" natif
        this.convertDateFields();
    }

    getFollowingFields(section, count) {
        const fields = [];
        let sibling = section.nextElementSibling;
        let collected = 0;

        while (sibling && collected < count) {
            // Vérifier que c'est un champ gfield et pas une autre section
            // Exclure les champs commentaire (gf-participant-comment, gf-participant-comment-title)
            const isCommentField = sibling.classList.contains('gf-participant-comment') ||
                                   sibling.classList.contains('gf-participant-comment-title');

            if (sibling.classList.contains('gfield') && !sibling.classList.contains('gsection') && !isCommentField) {
                fields.push(sibling);
                collected++;
            } else if (sibling.classList.contains('gsection')) {
                // On a atteint une autre section, on arrête
                break;
            }
            sibling = sibling.nextElementSibling;
        }

        return fields;
    }

    convertDateFields() {
        // Trouver tous les champs date dans les groupes participants
        const dateFields = this.wrapper.querySelectorAll('.gf-participant-birthdate input[type="text"].datepicker');
        dateFields.forEach(textInput => {
            if (textInput.dataset.converted) return; // Déjà converti

            // Créer un nouvel input type="date"
            const dateInput = document.createElement('input');
            dateInput.type = 'date';
            dateInput.name = textInput.name;
            dateInput.id = textInput.id;
            dateInput.className = 'gf-native-date';
            dateInput.required = textInput.required;

            // Copier la valeur si elle existe (format dd/mm/yyyy -> yyyy-mm-dd)
            if (textInput.value) {
                const parts = textInput.value.split('/');
                if (parts.length === 3) {
                    dateInput.value = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
            }

            // Remplacer l'input text par l'input date
            textInput.parentNode.replaceChild(dateInput, textInput);

            // Supprimer l'icône du datepicker si elle existe
            const fieldContainer = dateInput.closest('.gf-participant-birthdate');
            if (fieldContainer) {
                const icon = fieldContainer.querySelector('.gform-icon--calendar, .ui-datepicker-trigger');
                if (icon) icon.remove();
            }
        });
    }

    enableFields(group) {
        const inputs = group.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.disabled = false;
        });
    }

    disableFields(group) {
        const inputs = group.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.disabled = true;
        });
    }

    setFieldsRequired(group, required) {
        const inputs = group.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            if (required) {
                // Restaurer le required original si on l'avait sauvegardé
                if (input.dataset.wasRequired === 'true') {
                    input.required = true;
                }
            } else {
                // Sauvegarder l'état required original et le désactiver
                if (input.required) {
                    input.dataset.wasRequired = 'true';
                }
                input.required = false;
            }
        });
    }
}
